export const clearNewSignupDataLayerEvent = () => {
    localStorage.removeItem('alreadySentDataLayerEventForTempUser');
};
